var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetaverse901(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22.43 16.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fe8794;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{isolation:isolate;}.cls-6{fill:#f4f7fa;}.cls-16,.cls-51,.cls-7{mix-blend-mode:soft-light;}.cls-8{clip-path:url(#clip-path);}.cls-9{fill:#fcfdfe;}.cls-10{clip-path:url(#clip-path-2);}.cls-11{clip-path:url(#clip-path-3);}.cls-12{clip-path:url(#clip-path-4);}.cls-13{fill:#97a6b7;}.cls-14,.cls-16{fill:#fff;}.cls-15{fill:url(#linear-gradient-7);}.cls-16,.cls-51{opacity:0.5;}.cls-17{fill:url(#linear-gradient-8);}.cls-18{fill:url(#linear-gradient-9);}.cls-19{fill:url(#linear-gradient-10);}.cls-20{fill:url(#linear-gradient-11);}.cls-21{fill:url(#linear-gradient-12);}.cls-22{fill:url(#linear-gradient-13);}.cls-23{fill:url(#linear-gradient-14);}.cls-24{fill:url(#linear-gradient-15);}.cls-25{fill:url(#linear-gradient-16);}.cls-26{fill:url(#linear-gradient-17);}.cls-27{fill:url(#linear-gradient-18);}.cls-28{fill:url(#linear-gradient-19);}.cls-29,.cls-32,.cls-41,.cls-44,.cls-48{mix-blend-mode:multiply;}.cls-29,.cls-32,.cls-41{opacity:0.3;}.cls-29{fill:url(#linear-gradient-20);}.cls-30{fill:url(#linear-gradient-21);}.cls-31{fill:url(#linear-gradient-22);}.cls-32{fill:url(#linear-gradient-23);}.cls-33{fill:url(#linear-gradient-24);}.cls-34{fill:url(#linear-gradient-25);}.cls-35{fill:#26264f;}.cls-36{fill:url(#linear-gradient-26);}.cls-37{fill:url(#linear-gradient-27);}.cls-38{fill:url(#linear-gradient-28);}.cls-39{fill:url(#linear-gradient-29);}.cls-40{fill:url(#linear-gradient-30);}.cls-41{fill:url(#linear-gradient-31);}.cls-42{fill:url(#linear-gradient-32);}.cls-43{fill:url(#linear-gradient-33);}.cls-44,.cls-48{opacity:0.2;}.cls-44{fill:url(#linear-gradient-34);}.cls-45{fill:url(#linear-gradient-35);}.cls-46{fill:url(#linear-gradient-36);}.cls-47{fill:url(#linear-gradient-37);}.cls-48{fill:url(#linear-gradient-38);}.cls-49{fill:url(#linear-gradient-39);}.cls-50{fill:url(#linear-gradient-40);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 14.47,
    y1: 3.22,
    x2: 17.12,
    y2: 20.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e38ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 5.26,
    y1: 7.07,
    x2: 7.07,
    y2: 18.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.3,
    y1: 11.14,
    x2: 8.53,
    y2: 11.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#febc46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.55,12a.92.92,0,0,1-.38,0c-.36-.24-1.07-.63-1.19-1.06,0-.07.29-.25.31-.34a.92.92,0,0,0,.32-.43c.24-.68-1.09-1.35-.07-2.09.75-.53,1.55-.49,1-1.74s-.31-3.92,1.37-3.49c1,.25.54,1.6,1.22,2.27s.54,1.37-.12,2.1-.1.94.39,1.58-.72,1.39-1.35,1.62S14.41,11.4,14.55,12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.09,11.88a1,1,0,0,1-.33-.19c-.25-.35-.76-1-.71-1.42,0-.08.36-.13.41-.2a.87.87,0,0,0,.46-.29c.48-.54-.5-1.64.72-2,.9-.23,1.63.11,1.6-1.24s1.19-3.76,2.59-2.75c.8.58-.1,1.68.28,2.55s0,1.47-.9,1.91-.45.83-.23,1.61-1.19,1-1.86,1S14.2,11.23,14.09,11.88Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7,12.82a.54.54,0,0,0,.24-.12c.18-.22.56-.62.56-.93,0,0-.24-.1-.27-.15a.61.61,0,0,1-.3-.22C7,11,7.69,10.3,6.87,10c-.59-.19-1.11,0-1-.92s-.6-2.61-1.61-2c-.57.36,0,1.15-.33,1.73s-.07,1,.51,1.34.26.59.07,1.1.75.76,1.21.78S7,12.38,7,12.82Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.14,13.43a.64.64,0,0,0,.18-.19c.09-.28.29-.79.17-1.07,0-.05-.26,0-.31,0a.68.68,0,0,1-.36-.1c-.42-.25,0-1.17-.87-1.12-.63,0-1,.4-1.29-.48S4.12,8.23,3.41,9.17c-.4.54.41,1.08.34,1.72s.31.95,1,1,.46.45.48,1,1,.42,1.42.28S7.94,13,8.14,13.43Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 11.87,
    y1: 4.9,
    x2: 7.22,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 12.54,
    y1: 0.74,
    x2: 15.27,
    y2: 5.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 15.83,
    y1: 1.45,
    x2: 10.64,
    y2: 8.11,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -4164.91,
    y1: 4.37,
    x2: -4163.81,
    y2: 4.37,
    gradientTransform: "matrix(-1, 0, 0, 1, -4155.68, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -3165.22,
    y1: 6.44,
    x2: -3163.08,
    y2: 6.44,
    gradientTransform: "matrix(-1, 0, 0, 1, -3154.09, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 3102.3,
    y1: -911.33,
    x2: 3102.4,
    y2: -909.67,
    gradientTransform: "matrix(0.96, 0.29, -0.29, 0.96, -3223.99, -24.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -3164.21,
    y1: 6.52,
    x2: -3162.08,
    y2: 6.52,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 9.03,
    y1: 9.31,
    x2: 9.17,
    y2: 9.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -3164.08,
    y1: 5.11,
    x2: -3162.16,
    y2: 7.44,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -3152.15,
    y1: -105.93,
    x2: -3154.68,
    y2: -103.8,
    gradientTransform: "matrix(-1, -0.05, -0.05, 1, -3148.8, -52.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 6.68,
    y1: 5.18,
    x2: 8.74,
    y2: 3.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 7.27,
    y1: 3.06,
    x2: 8,
    y2: 3.06,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 7.95,
    y1: 2.67,
    x2: 6.8,
    y2: 8.21,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 6.75,
    y1: 5.25,
    x2: 8.81,
    y2: 3.4,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 7.54,
    y1: 5.58,
    x2: 9.16,
    y2: 5.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 8.49,
    y1: 5.15,
    x2: 10.72,
    y2: 5.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -1321.06,
    y1: 4.56,
    x2: -1320,
    y2: 5.61,
    gradientTransform: "matrix(-1, 0, 0, 1, -1310.86, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 7.54,
    y1: 5.16,
    x2: 5.96,
    y2: 3.62,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 7.81,
    y1: 5.35,
    x2: 8.35,
    y2: 5.35,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 13.9,
    y1: 11,
    x2: 10.77,
    y2: 14.69,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 12.57,
    y1: 11.44,
    x2: 12.34,
    y2: 12.5,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 14.67,
    y1: 11.35,
    x2: 17.35,
    y2: 13.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 3314.94,
    y1: -263.2,
    x2: 3316.61,
    y2: -261.1,
    gradientTransform: "translate(-3255.7 -591.02) rotate(14.93)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 3315.02,
    y1: -263.31,
    x2: 3316.89,
    y2: -260.96,
    gradientTransform: "translate(-3255.7 -591.02) rotate(14.93)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 13.68,
    y1: 12.39,
    x2: 16.36,
    y2: 14.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 14.08,
    y1: 11.97,
    x2: 16.76,
    y2: 14.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 7.91,
    y1: 9.92,
    x2: 7.71,
    y2: 15.1,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 5.3,
    y1: 12.78,
    x2: 10.23,
    y2: 12.78,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 5.04,
    y1: 13.81,
    x2: 6.21,
    y2: 13.81,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 5.92,
    y1: 14.5,
    x2: 11.89,
    y2: 14.5,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 6.69,
    y1: 14.72,
    x2: 11.89,
    y2: 14.72,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 6.89,
    y1: 14.56,
    x2: 6.8,
    y2: 17.82,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 11.3,
    y1: 9.9,
    x2: 9.16,
    y2: 16.38,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 9.76,
    y1: 14.4,
    x2: 9.67,
    y2: 17.83,
    xlinkHref: "#linear-gradient-7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M4.7,3.38a7.25,7.25,0,0,1,5.78-3c.17,0,3.51.19,4.74,2.38.91,1.61-.05,3.05,1.06,4.15S18.44,7.24,19,8c.91,1.18-.53,4.38-2.75,6.16s-6.67,3.2-10.08.74C2.38,12.16,2.42,6.5,4.7,3.38Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.55,12a.92.92,0,0,1-.38,0c-.36-.24-1.07-.63-1.19-1.06,0-.07.29-.25.31-.34a.92.92,0,0,0,.32-.43c.24-.68-1.09-1.35-.07-2.09.75-.53,1.55-.49,1-1.74s-.31-3.92,1.37-3.49c1,.25.54,1.6,1.22,2.27s.54,1.37-.12,2.1-.1.94.39,1.58-.72,1.39-1.35,1.62S14.41,11.4,14.55,12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13.6,11.49h0a8.39,8.39,0,0,0,1.84-8.9h0a9.45,9.45,0,0,1,.37,4.75A7.84,7.84,0,0,1,13.6,11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M17.7,9.09a6.26,6.26,0,0,0-3,1h0a6.2,6.2,0,0,1,3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14,11.05h0a1.83,1.83,0,0,0,0-1.53,5.36,5.36,0,0,0-.79-1.41h0a5.4,5.4,0,0,1,.79,1.42A1.82,1.82,0,0,1,14,11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M15.86,7.1h0a3.39,3.39,0,0,1,1.85-1.5v0A3.36,3.36,0,0,0,15.86,7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M16,5.06h0a3.49,3.49,0,0,0-1.58-1.92v0A3.58,3.58,0,0,1,16,5.06Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.09,11.88a1,1,0,0,1-.33-.19c-.25-.35-.76-1-.71-1.42,0-.08.36-.13.41-.2a.87.87,0,0,0,.46-.29c.48-.54-.5-1.64.72-2,.9-.23,1.63.11,1.6-1.24s1.19-3.76,2.59-2.75c.8.58-.1,1.68.28,2.55s0,1.47-.9,1.91-.45.83-.23,1.61-1.19,1-1.86,1S14.2,11.23,14.09,11.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M13.42,11v0a8.48,8.48,0,0,0,5.05-7.6h0A9.36,9.36,0,0,1,17.05,8,8,8,0,0,1,13.42,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18.13,10.27A6.2,6.2,0,0,0,15,10.11v0a6.13,6.13,0,0,1,3.13.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M14,10.77v0a1.83,1.83,0,0,0,.61-1.4,5.38,5.38,0,0,0-.21-1.6h0a5.34,5.34,0,0,1,.21,1.6A1.84,1.84,0,0,1,14,10.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M17.16,7.76v0A3.48,3.48,0,0,1,19.43,7V7A3.4,3.4,0,0,0,17.16,7.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M18,5.9h0a3.5,3.5,0,0,0-.75-2.36h0A3.48,3.48,0,0,1,18,5.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7,12.82a.54.54,0,0,0,.24-.12c.18-.22.56-.62.56-.93,0,0-.24-.1-.27-.15a.61.61,0,0,1-.3-.22C7,11,7.69,10.3,6.87,10c-.59-.19-1.11,0-1-.92s-.6-2.61-1.61-2c-.57.36,0,1.15-.33,1.73s-.07,1,.51,1.34.26.59.07,1.1.75.76,1.21.78S7,12.38,7,12.82Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M7.54,12.27v0a5.7,5.7,0,0,1-3-5.4h0A6.35,6.35,0,0,0,5.24,10,5.34,5.34,0,0,0,7.54,12.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4.38,11.54a4.23,4.23,0,0,1,2.12,0h0a4.16,4.16,0,0,0-2.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M7.16,12.07h0a1.24,1.24,0,0,1-.34-1A3.62,3.62,0,0,1,7.06,10H7a3.7,3.7,0,0,0-.22,1.08A1.24,1.24,0,0,0,7.16,12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M5.17,9.87h0a2.35,2.35,0,0,0-1.51-.59h0A2.33,2.33,0,0,1,5.17,9.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4.69,8.57h0A2.41,2.41,0,0,1,5.34,7h0A2.41,2.41,0,0,0,4.69,8.57Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M8.14,13.43a.64.64,0,0,0,.18-.19c.09-.28.29-.79.17-1.07,0-.05-.26,0-.31,0a.68.68,0,0,1-.36-.1c-.42-.25,0-1.17-.87-1.12-.63,0-1,.4-1.29-.48S4.12,8.23,3.41,9.17c-.4.54.41,1.08.34,1.72s.31.95,1,1,.46.45.48,1,1,.42,1.42.28S7.94,13,8.14,13.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8.41,12.73h0a5.79,5.79,0,0,1-4.85-3.9h0a6.37,6.37,0,0,0,1.87,2.66A5.36,5.36,0,0,0,8.41,12.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M5.19,13.22a4.2,4.2,0,0,1,2-.75v0a4.24,4.24,0,0,0-2,.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M8,12.69H8a1.27,1.27,0,0,1-.68-.79,3.67,3.67,0,0,1-.19-1.08h0a3.59,3.59,0,0,0,.2,1.08A1.25,1.25,0,0,0,8,12.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M5.3,11.38h0a2.37,2.37,0,0,0-1.64,0v0A2.31,2.31,0,0,1,5.3,11.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4.37,10.35h0a2.37,2.37,0,0,1,0-1.69h0A2.35,2.35,0,0,0,4.37,10.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M16.73,6.61h0V6.32a.18.18,0,0,0-.17-.17L8.12,5.92,5.37,5.84H5.31a.18.18,0,0,0-.2.18v7.49a.22.22,0,0,0,0,.08h0a.21.21,0,0,0,.19.1h0l6.54-.26h0l4.71-.19a.17.17,0,0,0,.17-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M16.84,6.51l0,6.57a.18.18,0,0,1-.17.17l-4.81.19-6.5.25H5.35a.17.17,0,0,1-.15-.17V6.22h0l3.23.08,8.29.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M16.83,6.32v.29h-.11L8.5,6.41,5.2,6.33V6a.18.18,0,0,1,.17-.18h0l2.72.07,8.54.24A.17.17,0,0,1,16.83,6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M12,13.44l-6.5.25H5.4a.21.21,0,0,1-.18-.1h0l0-.32V6a.19.19,0,0,1,.21-.18H5.5l2.72.07h0a1.5,1.5,0,0,1,.32.38h0a.31.31,0,0,1,.05.1h0a1.57,1.57,0,0,1,.13.4c.23,1,.41,1.5.68,1.74h0l.1.07h0l.09,0h0l.1.05h0l.12,0h0l.16.05h0l.12,0h0l.1,0h0l.09,0h0l.09,0h0A.64.64,0,0,1,10.6,9h0l.09,0h0l.1.06h0l0,0,.19.15h0l0,0h0a1.82,1.82,0,0,1,.43.62h0l.05.14h0a2,2,0,0,1-.11,1.49,1.67,1.67,0,0,0,.54,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M9.39,7.75A.22.22,0,0,0,9.26,8a.27.27,0,0,0,.19.2c.11,0,.15,0,.26,0a.53.53,0,0,1,.37.32c.06.13,0,.15.05.3a1.12,1.12,0,0,0,.44.54c.16.12.39.27.43.22s0,0,0-.07-.1-.1-.2-.18-.16-.13-.15-.18.13-.09.21-.07a.27.27,0,0,1,.15.15s0,.07,0,.08,0,0,0,0,0-.08,0-.11,0-.14.09-.21.14-.12.27-.26.13-.14.14-.21a.29.29,0,0,0-.11-.22c-.08-.08-.22-.13-.28-.08s0,.13-.06.2a.21.21,0,0,1-.19,0,.23.23,0,0,1-.14-.18.21.21,0,0,1,0-.13A.27.27,0,0,1,11,8c.15,0,.18.05.26,0s.16-.07.16-.12-.12-.08-.26-.23-.1-.11-.1-.17a.31.31,0,0,1,.12-.17l.15-.09s0,0,0,0l0,0a.34.34,0,0,0-.15,0,.93.93,0,0,0-.25.12,1,1,0,0,1-.25.08c-.13,0-.17,0-.24,0s0,.08-.11.15A.49.49,0,0,1,10,7.7l-.29,0C9.51,7.74,9.46,7.71,9.39,7.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M11.52,7.29c-.13,0-.24,0-.27.13a.13.13,0,0,0,0,.13c.07.06.17,0,.25,0s0,.07.07.27a.53.53,0,0,0,.11.26s.06.09.1.08,0-.12.12-.2,0,0,.18-.08.13,0,.14-.07-.08-.2,0-.3,0,0,.08-.08.07-.11.07-.11-.07,0-.21-.07a1.31,1.31,0,0,0-.33,0l-.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M11.2,9.54a.29.29,0,0,0-.1.19.76.76,0,0,0,.07.31c.06.18.09.28.1.33a1.66,1.66,0,0,1-.07.42c0,.24,0,.31,0,.35s.2,0,.2,0l-.05,0a.25.25,0,0,1,0-.19c0-.1.1-.15.21-.26a1.1,1.1,0,0,0,.27-.32.63.63,0,0,0,.07-.36.51.51,0,0,0-.1-.25.57.57,0,0,0-.3-.21A.33.33,0,0,0,11.2,9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M12.42,9a1.62,1.62,0,0,0-.11.28c0,.08,0,.26,0,.33s.18,0,.29.05a.33.33,0,0,1,.11.15,1.19,1.19,0,0,1,.07.4c0,.08.05.35.16.36s.18-.15.19-.18a1,1,0,0,0,.09-.29c0-.2,0-.23.06-.28s.12-.08.14-.15a.19.19,0,0,0,0-.12c-.06-.11-.14-.1-.19-.2a.19.19,0,0,1,0-.13s0,0,.06.06a.72.72,0,0,0,.07.11.17.17,0,0,0,.15.06s.12,0,.13-.09,0-.08-.07-.13l-.06-.07s0,0,.12,0l.13.06s.06,0,.14.18.11.22.13.21,0,0,0-.09a.43.43,0,0,1,0-.18s.06-.08.11-.07.05.05.12.14a.63.63,0,0,0,.12.14s.06,0,.09,0a.12.12,0,0,0,0-.12c0-.06-.07-.06-.06-.1s.09-.07.1-.08.08,0,.11,0a.18.18,0,0,0,.05-.19c0-.06-.05-.09,0-.12s.05,0,.11,0A.24.24,0,0,0,15,8.82a.29.29,0,0,0,0-.14.41.41,0,0,0,0-.12c0-.09,0-.09,0-.12s.11,0,.27-.08a.57.57,0,0,1,.17,0s-.1.07-.11.16a.14.14,0,0,0,.07.14s0-.07,0-.14a.23.23,0,0,1,.07-.11s.08,0,.12,0,0-.05.05-.08.17,0,.18,0-.08-.1-.19-.13-.11,0-.22,0a1.45,1.45,0,0,1-.3-.11,1,1,0,0,0-.21-.07H14.8a.51.51,0,0,1-.22-.09c-.05-.06,0-.08-.08-.12s-.16,0-.24,0a1.12,1.12,0,0,0-.26.14c-.12.08-.16.12-.23.11s-.06,0-.12,0-.06,0-.16.06a.39.39,0,0,1-.18,0c-.06,0-.07-.06-.14-.09a.3.3,0,0,0-.23,0,.36.36,0,0,0-.26.16c-.06.1,0,.19-.07.24s-.1,0-.15,0,0,.17,0,.23.06.16.05.25A.43.43,0,0,1,12.42,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M13.47,10s-.07.11-.06.22,0,.09,0,.09.05-.06.05-.07a.25.25,0,0,0,0-.11S13.49,10,13.47,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.38,9.76l0,0c.05,0,.07.07.12.08s.13,0,.14,0,0-.07,0-.09-.05,0-.13,0S14.39,9.75,14.38,9.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.64,9.56s0,0,0,.1,0,.05,0,.06a.07.07,0,0,0,.1,0,.18.18,0,0,0,0-.1S14.66,9.55,14.64,9.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.94,9.83A.3.3,0,0,0,15,9.9s.14.06.17,0a.09.09,0,0,0,0-.07s0,0-.08,0-.17-.06-.18,0S14.94,9.82,14.94,9.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.72,9.42s0,.09,0,.16,0,.07.06.07,0-.07,0-.11A.21.21,0,0,0,14.72,9.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.84,9s0,0,.1,0a.38.38,0,0,0,.12-.15s0,0,0,0a.24.24,0,0,1,0,.09.24.24,0,0,1-.12.18h-.05S14.84,9.06,14.84,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.73,10.16c-.07.07-.11.06-.12.1s0,.06.05.16,0,.09,0,.1.05-.07.13-.1a.22.22,0,0,1,.16,0s0,.05.09.11.07.06.09.05.07-.07.08-.11a.38.38,0,0,0,0-.2s0,0-.13-.22a.14.14,0,0,0-.21-.07l-.08.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M7.16,9.37a1.05,1.05,0,0,1-1.09-1,1,1,0,0,1,1.09-1,1.05,1.05,0,0,1,1.07,1A1,1,0,0,1,7.16,9.37Zm0-1.93a1,1,0,0,0-1,.92,1,1,0,0,0,1,1,1,1,0,0,0,1-.93A1,1,0,0,0,7.16,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M7.16,9.37c-.22,0-.4-.44-.4-1s.18-1,.4-1,.4.44.4,1S7.38,9.37,7.16,9.37Zm0-1.92c-.16,0-.34.36-.33.92s.17.94.33.94.34-.37.33-.93S7.32,7.45,7.16,7.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M7.16,9.37a.91.91,0,0,1-.76-1c0-.55.34-1,.76-1a.91.91,0,0,1,.75,1A.89.89,0,0,1,7.16,9.37Zm0-1.92c-.39,0-.7.4-.7.92s.32.94.7.94.69-.41.69-.92A.86.86,0,0,0,7.16,7.45Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "8.21 8.43 6.1 8.4 6.1 8.35 8.21 8.38 8.21 8.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "8.08 7.98 6.18 7.95 6.18 7.89 8.08 7.92 8.08 7.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "8.08 8.86 6.18 8.84 6.18 8.79 8.08 8.8 8.08 8.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M6.48,10.12a.17.17,0,0,1-.17.16.16.16,0,1,1,0-.32A.17.17,0,0,1,6.48,10.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M6.63,10.53a.35.35,0,0,0-.32-.18.35.35,0,0,0-.33.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M7.34,10.11a.16.16,0,0,1-.17.16.16.16,0,1,1,0-.31A.16.16,0,0,1,7.34,10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M7.49,10.52a.34.34,0,0,0-.32-.18.35.35,0,0,0-.32.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M8.19,10.11a.16.16,0,0,1-.17.16A.16.16,0,1,1,8,10,.16.16,0,0,1,8.19,10.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M8.34,10.52A.3.3,0,0,0,8,10.34a.34.34,0,0,0-.32.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M8.41,10.72a.06.06,0,0,1-.06.06l-2.29,0s-.07,0-.07-.05H6s0-.06.07-.06l2.29,0a.05.05,0,0,1,.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M16,11.34l-6.67.09A.25.25,0,0,1,9,11.19v-4a.25.25,0,0,1,.27-.24l6.65.19a.24.24,0,0,1,.24.24l0,3.74A.24.24,0,0,1,16,11.34ZM9.3,7a.2.2,0,0,0-.21.19v4a.2.2,0,0,0,.21.19l6.66-.1a.17.17,0,0,0,.17-.18l0-3.74a.18.18,0,0,0-.18-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M10.22,11.93a.07.07,0,0,1-.07.06l-4.08.09A.08.08,0,0,1,6,12H6a.08.08,0,0,1,.08-.07l4.08-.08a.07.07,0,0,1,.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M10.22,12.35a.07.07,0,0,1-.07.07l-4.08.1A.08.08,0,0,1,6,12.45H6a.09.09,0,0,1,.08-.07l4.08-.09a.07.07,0,0,1,.07.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M10.22,12.78a.07.07,0,0,1-.07.06L6.07,13A.08.08,0,0,1,6,12.89H6s0-.06.08-.07l4.08-.11a.07.07,0,0,1,.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.54,11.84s0,.07-.06.07L10.74,12a.07.07,0,0,1-.07-.06h0a.07.07,0,0,1,.07-.07l3.74-.07a.06.06,0,0,1,.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.55,12.25a.07.07,0,0,1-.07.06l-3.74.09s-.07,0-.07-.06h0a.07.07,0,0,1,.07-.06l3.74-.09a.07.07,0,0,1,.07.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M14.55,12.66a.06.06,0,0,1-.06.06l-3.75.11a.07.07,0,0,1-.07-.07h0a.07.07,0,0,1,.07-.06l3.74-.1s.07,0,.07.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M16.12,12.59a.11.11,0,0,1-.09.09h0a.09.09,0,0,1-.09-.09v-.73a.09.09,0,0,1,.08-.09h0a.09.09,0,0,1,.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M15.77,12.6a.11.11,0,0,1-.09.09h0a.09.09,0,0,1-.09-.09V12a.09.09,0,0,1,.08-.09h0a.09.09,0,0,1,.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M15.05,12.62a.09.09,0,0,1-.08.09h0a.08.08,0,0,1-.08-.09v-.34A.08.08,0,0,1,15,12.2h0a.08.08,0,0,1,.09.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M15.4,12.61a.11.11,0,0,1-.09.09h0a.08.08,0,0,1-.08-.09v-.47a.09.09,0,0,1,.09-.09h0a.08.08,0,0,1,.09.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M16.84,1.51l-5.12-.27a.7.7,0,0,0-.76.69v2.8a.77.77,0,0,0,.76.76l1.68,0,.78.92a.14.14,0,0,0,.18,0h0l.75-.9,1.73,0a.67.67,0,0,0,.7-.68V2.25A.75.75,0,0,0,16.84,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M16.94,1.43l-5.11-.27a.69.69,0,0,0-.77.69v2.8a.77.77,0,0,0,.77.75l1.67,0,.76.89a.14.14,0,0,0,.21,0l.75-.86,1.72,0a.68.68,0,0,0,.7-.68V2.17A.74.74,0,0,0,16.94,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M15.78,2.69V4.57h0a4.4,4.4,0,0,1-1.43.13,4.36,4.36,0,0,1-1.42-.13h0V2.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M15.78,4.27v.3h0a4.4,4.4,0,0,1-1.43.13,4.36,4.36,0,0,1-1.42-.13h0V3c.21.09.55.26.61.57s.72.58,1.36.48A1.37,1.37,0,0,1,15.78,4.27Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "16.53 2.81 14.39 1.75 12.24 2.81 12.16 2.81 12.16 2.85 12.16 2.85 14.39 3.95 16.62 2.85 16.62 2.85 16.62 2.81 16.53 2.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "14.39 1.7 12.16 2.8 14.39 3.9 16.62 2.8 14.39 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M16.6,4.33s0,0,0,0V2.86s0-.06-.07-.06H14.39a0,0,0,0,1,0,0s0,0,0,0h2.13c.07,0,.1,0,.1.11V4.3S16.62,4.33,16.6,4.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M16.69,4.07l0,0a.06.06,0,0,0-.1,0l0,0a.06.06,0,0,0,0,0V4.5s0,0,.09,0l.09,0V4.11S16.69,4.08,16.69,4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M8.31,3.22c.14,0,.33.22.48.43a1.57,1.57,0,0,1,.43,1.13c-.07.44-.45.78-.56.73s.09-.34-.05-.73-.29-.32-.41-.63S8.14,3.27,8.31,3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M8.38,5.24a4.11,4.11,0,0,1,1.46.65c.15.1.22.17.25.27.22.55-.87,1.39-1,1.47L9,7.28c.11-.62.3-.81.46-.87s.11,0,.11,0a5.46,5.46,0,0,1-.81-.13c-.39-.14-.79-.5-.72-.74C8,5.44,8.06,5.31,8.38,5.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M9.07,9.28A.09.09,0,0,0,9,9.36a.78.78,0,0,0,.14.36c.07.09.08,0,.07-.12a1.12,1.12,0,0,0,0-.29S9.07,9.28,9.07,9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M9.29,6.05c.13,0,.43,0,.51.12s-.05.32-.12.43c-.2.32-.39.35-.53.55A.64.64,0,0,0,9,7.48L9,7.28c.11-.62.3-.81.46-.87s.11,0,.11,0a5.46,5.46,0,0,1-.81-.13C8.35,6.1,8,5.79,8,5.55A2.17,2.17,0,0,0,9.29,6.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M9,9.06c0,.08,0,.15,0,.2a.81.81,0,0,0,0,.19s.06.11.08.11,0-.09,0-.33V9.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M8,5.28A3,3,0,0,1,8.8,6a2.36,2.36,0,0,1,.57,1.07,3.49,3.49,0,0,1,0,1c-.06.47-.14.85-.2,1.12l-.09,0a2,2,0,0,1-.24-.72c-.06-.52.13-.68,0-1s-.32-.51-.78-.9-.73-.51-.87-.9a.3.3,0,0,1,0-.23C7.28,5.28,7.58,5.22,8,5.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M7.64,3.25a.79.79,0,0,0,.45-.15.47.47,0,0,0,.21-.38.39.39,0,0,0-.21-.28.59.59,0,0,0-.37,0,1.82,1.82,0,0,0-.35.11c-.29.08-.39-.09-.68-.08s-.41.3-.73.31-.42-.34-.78-.4A1.17,1.17,0,0,0,4,3.39a1,1,0,0,0,.6.87c.2.07.41,0,.47.17S5,4.59,5,4.75a.52.52,0,0,0,.22.36c.26.22.84.11,1.24-.19C7.17,4.38,7.06,3.38,7.64,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M6.81,3.18c.25,0,.52-.05.84-.06.65,0,.74.08.77.14s0,.17,0,.37a1.81,1.81,0,0,0,.05.31c0,.12,0,.19,0,.48s-.08.57,0,.72.16.11.15.16-.38,0-.85.25a2.9,2.9,0,0,0-.36.2C7.16,5.89,7.12,6,7,6A1.07,1.07,0,0,1,5.83,6c-.1-.09-.18-.23-.15-.28s.26.09.45,0,.1-.16.25-.28.3-.07.42-.16.1-.49,0-1.07C6.83,4,6.81,3.6,6.81,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M7.52,3.05l-.25.14a1.12,1.12,0,0,0,.72,0s0,0-.12-.06,0-.08,0-.15l0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M7.75,2.83a.21.21,0,0,0,.09.23c.12.06.32-.21.28-.31A.18.18,0,0,0,8,2.66a.2.2,0,0,0-.21.1s0,0,0,0,0,0,0,0A.08.08,0,0,0,7.75,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M8,5.22c-.13,0-.15.18-.34.24s-.24,0-.41,0-.37.34-.41.32,0-.27.17-.43.41-.1.53-.29a.32.32,0,0,0,0-.28c-.06-.13-.21-.08-.29-.19s.19-.51.1-.79c0-.11-.16-.25-.54-.34,0,.28,0,.51,0,.69.05.58.14.92,0,1.07s-.24,0-.42.16-.12.22-.25.28-.4-.06-.45,0,.05.19.15.28A1.07,1.07,0,0,0,7,6c.12-.06.16-.12.41-.26a2.9,2.9,0,0,1,.36-.2,3,3,0,0,1,.75-.18C8.23,5.18,8.06,5.17,8,5.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M9.12,5.46l-1.48.07a.05.05,0,0,0,0,0l0,.07a0,0,0,0,0,0,.07l1.57-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M10.66,4.63l-1.53,0A.15.15,0,0,0,9,4.73l-.53.93,1.62-.06a.19.19,0,0,0,.11-.07l.49-.82A.06.06,0,0,0,10.66,4.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M9,4.73a.15.15,0,0,1,.11-.07h0a.19.19,0,0,0,.05.13c.09.12.25,0,.36.17s0,.29.13.41.32,0,.54.11l0,0a.19.19,0,0,1-.11.07l-1.62.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M7.82,5.41l.06-.15c-.21-.06-.51-.15-.81-.26A.2.2,0,0,1,7,4.92c-.16-.21.24-.57.23-1s-.2-.7-.38-.71c-.35,0-1.13,1.5-.47,2.14A1.37,1.37,0,0,0,7.82,5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M7.88,5.26a.41.41,0,0,1,.3,0,.41.41,0,0,1,.12.09s.06.08,0,.11-.08,0-.16,0H8c-.11,0-.16,0-.2,0a.09.09,0,0,1,0-.1S7.86,5.27,7.88,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M13,12.79l-.84-2a.18.18,0,0,1,.12-.24l1.54-.37a.17.17,0,0,1,.2.1l.77,1.89a.18.18,0,0,1-.11.24l-1.47.45A.19.19,0,0,1,13,12.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M13,12.69l-.78-1.83a.16.16,0,0,1,.11-.22l1.43-.35a.16.16,0,0,1,.19.09l.72,1.77a.15.15,0,0,1-.1.21l-1.37.42A.16.16,0,0,1,13,12.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M12.55,12.15l0-.23-.13-.25a.27.27,0,0,1,0-.12V11.3l.16.37.15-.11s0,.06,0,.09,0,.28,0,.3v.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M13.83,10.68a1.27,1.27,0,0,1,.53-.58c.33-.21.54-.18,1.3-.29,1-.15,1.13-.3,1.47-.18a1.55,1.55,0,0,1,.79.74c.54.94-.09,1.42.07,3.28.07.76.24,1.42-.17,1.82a1.45,1.45,0,0,1-.37.21,3.5,3.5,0,0,1-1.86.24c-.45-.05-.68-.07-.8-.23s0-.59,0-1.15a3.92,3.92,0,0,0-.26-1.37C14.14,11.67,13.59,11.26,13.83,10.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M15.52,9.26a.45.45,0,0,1,.05-.35c.08-.14.1-.16.13-.18l.05,0h0a.45.45,0,0,1,.16,0c.07,0,.14.3.12.7v0a1.37,1.37,0,0,1,0,.19c0,.06.09.06.15.05.24,0,.36,0,.37,0S16.32,10,16,10s-.85,0-.81-.11.38-.13.48-.23a.29.29,0,0,0,.1-.23S15.55,9.38,15.52,9.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M15.61,8.58a.46.46,0,0,0,.08.28l.05.05v0c0,.08-.1.17-.08.2s.11,0,.12,0-.07.06,0,.09,0,0,.07,0,0,0,0,.06a.24.24,0,0,0,0,.07c0,.07.16.1.19.07v0l0-.06s.08-.07.14-.11a.36.36,0,0,0,.16-.18v0a.44.44,0,0,0,0-.3c-.07-.14-.22-.08-.35-.22s-.06-.37-.14-.39S15.6,8.35,15.61,8.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M15.72,9.1s.08,0,.08.06-.05.11-.1.1S15.68,9.16,15.72,9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M15.74,9l-.07.1s-.07.11-.12.05,0-.05-.05-.05h0v0a.53.53,0,0,0-.06.13.28.28,0,0,0,0,.18s0,.07.11.08,0,0,.13,0-.12-.09-.12-.11.08-.09.13-.2A.24.24,0,0,0,15.74,9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M16,15.38c-.14-.26.19-.62,0-1s-.52-.27-.67-.59.22-.67.2-1.25-.61-1.39-1-1.33-.25.38-.41.75a8.53,8.53,0,0,1,.45,1.23,3.92,3.92,0,0,1,.26,1.37c0,.56-.24.89,0,1.15s.35.18.8.23a3.5,3.5,0,0,0,1.86-.24l.22-.11C16.49,15.75,16.09,15.6,16,15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M12.5,12.11l.22-.1c.13.13.29.25.42.21s.15-.42.4-1.07.58-.92.74-1a.31.31,0,0,1,.22,0c.34.08.45,1,.36,1.61a1.89,1.89,0,0,1-.76,1.44,1.12,1.12,0,0,1-1,.1A1.14,1.14,0,0,1,12.5,12.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M10.4,12.68l-.17.12-.48.32s-.8-.35-1.41-.54A10.9,10.9,0,0,0,5.72,13a.73.73,0,0,0-.42.31h0l0,.07a.74.74,0,0,1,.09-.76A9.61,9.61,0,0,1,8,12,4.5,4.5,0,0,1,10.4,12.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M10.23,12.8l-.48.32s-.8-.35-1.41-.54A10.9,10.9,0,0,0,5.72,13a.73.73,0,0,0-.42.31v0s0-.5.39-.5,1,0,1.1-.18a.8.8,0,0,1,.74-.18c.24.08.64-.28.89-.12s.74.46,1,.42A1.33,1.33,0,0,1,10.23,12.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M6.21,13.77s-1-.4-1-.79c0,0,0-.32.17-.43A.71.71,0,0,0,5.1,13c0,.15-.13.77,0,.93l1,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M11.89,13.32l-.1.07L8.13,16l-.25.19-.08.05-.08.06a1.32,1.32,0,0,1-.3-.09A3.24,3.24,0,0,1,7.07,16h0a1.39,1.39,0,0,1-.21-.21h0L6,15s-.34-1,.15-1.4h0a.8.8,0,0,1,.42-.15,10.08,10.08,0,0,0,2.51-.18,1.91,1.91,0,0,0,.58-.31,1,1,0,0,1,.64-.26,7.41,7.41,0,0,1,1.1.43h0l.16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M11.89,14.17a1.09,1.09,0,0,1-.72,1l-3,.84-.3.09h0l.06.1a.78.78,0,0,1,0,.14H7.82l-.1,0a1.32,1.32,0,0,1-.3-.09A1.41,1.41,0,0,1,7.07,16h0L7,15.94l-.09-.1,0,0h0a.77.77,0,0,1-.13-.41l0-.44a1.1,1.1,0,0,1,0-.26h0a1.25,1.25,0,0,1,1-1l3.46-.65a.7.7,0,0,1,.29,0h0l.16.08a.58.58,0,0,1,.2.21.89.89,0,0,1,.1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M7.82,16.35l-.1,0a1.32,1.32,0,0,1-.3-.09A1.41,1.41,0,0,1,7.07,16h0a1.39,1.39,0,0,1-.21-.21h0L6,15s-.34-1,.15-1.4h0c.05,0,.18.13.2.15a.6.6,0,0,1,.17.38c0,.15,0,.32,0,.46a.34.34,0,0,0,.14.15h0a1.5,1.5,0,0,1,.25.15,5.91,5.91,0,0,1,.84,1.41A.31.31,0,0,1,7.82,16.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M12.31,14c0-.47-.33-.79-.75-.71l-3.46.65a1.21,1.21,0,0,0-1,1.23l0,.44a.82.82,0,0,0,1.1.71l3.34-.94a1.08,1.08,0,0,0,.72-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M12.22,14.34a1,1,0,0,1-.41.79,1.15,1.15,0,0,1-.25.12l-3.17.91a.77.77,0,0,1-1.07-.6l0-.4a1.06,1.06,0,0,1,.5-.93A1.44,1.44,0,0,1,8.25,14l3.27-.61a.58.58,0,0,1,.7.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M11.81,15.13a1.15,1.15,0,0,1-.25.12l-3.17.91a.77.77,0,0,1-1.07-.6l0-.4a1.06,1.06,0,0,1,.5-.93c.37-.06,1.23-.13,1.6.41.49.7,1.23,0,1.91.27A3.33,3.33,0,0,1,11.81,15.13Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverse901);
export default __webpack_public_path__ + "static/media/metaverse9-01.9b83243174a88d008ecabf072f06117b.svg";
export { ForwardRef as ReactComponent };